export default {
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    form: {
        padding: '2em 0em'
    },
    preview: {
        padding: '2em 2em',
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        margin: '2rem',
        maxHeight: '1140px',
        top: '0px',
        position: 'sticky',
    },
}